import styles from "./shopItem.module.css"
import Link from "next/link";
import { resolveImageUrl } from "../../lib/imageUrl";

export default function ShopItem({title, subTitle, image, prices, id}){
    // `image` can be either a bare filename (legacy showcase asset under
    // /images/shop) or a full URL produced by the admin's Blob upload. The
    // resolver picks the right rendering for each.
    const src = resolveImageUrl(image, 'shop');
    return(
        <div className={styles.item}>
            <Link href={`/weinkauf/shop/details?id=${id}`}>
                <div className={styles.link}>
                    <img alt="" className={styles.image} src={src}/>
                    <p className="title uppercase narrow" style={{marginBottom:0}}>{title}</p>
                    <p className="title uppercase narrow" style={{marginTop:0, lineHeight:"16px", height:"16px"}}>{subTitle}</p>
                </div>
            </Link>
            <p style={{marginTop:0}}className="narrow">{prices}</p>
            <Link href={{pathname:"/weinkauf/shop/details", query:{id: id}}}><p className="button x2 primary uppercase">Anzeigen</p></Link>
        </div>
    );
}